if (window.w_template_name == 'product') {
  (async () => {
    const productId = window.w_product_handle;

    const updateCartAttribute = async (name, value) => {
      try {
        const formData = new FormData();
        formData.append('attributes[' + name + ']', value);
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        });
        if (!response.ok) throw new Error('Failed to update cart attribute');
        console.log('Cart attribute updated');
      } catch (error) {
        console.error(error.message);
      }
    };

    const addRecentlyViewed = async (productId) => {
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      recentlyViewed = recentlyViewed.filter(id => id !== productId);
      recentlyViewed.unshift(productId);
      console.log(recentlyViewed, productId)
      if (recentlyViewed.length > 20) recentlyViewed.pop();
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
      await updateCartAttribute('rv', recentlyViewed.join(','));
    };

    await addRecentlyViewed(productId);
  })();

}


(() => {
  const tabContainer = document.getElementById('tab-container');
  const featuredColWrapper = document.querySelector('.featured-col-wrapper');
  const rvSlot = document.getElementById('rv-slot');

  const updateContentVisibility = (activeTab) => {
    featuredColWrapper.style.display = activeTab === "1" ? 'block' : 'none';
    rvSlot.style.display = activeTab === "2" ? 'grid' : 'none';
  };

  const setActiveTab = (activeTab) => {
    const tabs = tabContainer.getElementsByClassName('tab');
    for (const tab of tabs) {
      tab.classList.remove('active');
    }
    const activeTabElement = tabContainer.querySelector(`.tab[data-index="${activeTab}"]`);
    if (activeTabElement) {
      activeTabElement.classList.add('active');
      localStorage.setItem('cartdrawer-activeTab', activeTab);
      updateContentVisibility(activeTab);
    }
  };

  const initializeTabs = () => {
    let activeTab = localStorage.getItem('cartdrawer-activeTab') || "1";
    setActiveTab(activeTab);

    tabContainer.addEventListener('click', event => {
      if (event.target.classList.contains('tab')) {
        setActiveTab(event.target.getAttribute('data-index'));
      }
    });
  };

  const loadRecentlyViewedContent = async () => {
    try {
      const response = await fetch(`/?view=rv`);
      if (!response.ok) throw new Error('Failed to load recently viewed content');
      const text = await response.text();
      const div = document.createElement('div');
      div.innerHTML = text;
      const rvTemplate = div.querySelector('#rv-template');
      rvSlot.innerHTML = rvTemplate && rvTemplate.innerHTML.trim() ? rvTemplate.innerHTML : window.w_nodata;
    } catch (error) {
      console.error(error.message);
    }
  };

  document.addEventListener('on:cart-drawer:after-open', async (event) => {
    document.body.style.position = 'fixed';
    await loadRecentlyViewedContent();
  });

  document.addEventListener('on:cart-drawer:after-close', (event) => {
    document.body.style.position = 'relative';
  });

  initializeTabs();
})();

